// src/components/Navbar.js
import React from 'react';
import Navbar from '../components/NavBar';
import Footer from '../components/Footer';
import ChannelLogos from '../components/Channels/ChannelLogos';


const Channels = () => {
    return(
        <div>
            <head><script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-3081463517624663"
     crossOrigin="anonymous"></script></head>
            <Navbar />
            <ChannelLogos />
            <Footer />
        </div>
    )
};

export default Channels;
